<template>
  <div class="vm-block-shop">
    <div class="flex-box flex-justify-content-space-between flex-align-items-center pt8">
        <div>
            <div class="fs20 fwb black-8">{{$t('c.BlockShop.text1')}}</div>
            <span class="fs12 black-3 mt4">{{$t('c.BlockShop.text2')}}</span>
        </div>
        <div class="flex-box btn-box">
          <btn class="flex-box flex-center pt12 pb12 pr24 pl24 fs14" @click.native="$mixin_router_push(`/edit/shop`)"><i class="afd afd-plus fs12 mr8"></i>{{$t('c.BlockShop.text3')}}</btn>
          <btn class="flex-box flex-center pt12 pb12 pr24 pl24 fs14 look3 ml16" v-if="can_add_bundle" @click.native="$mixin_show_modal_bundle_type"><i class="afd afd-plus fs12 mr8"></i>{{$t('c.BlockShop.text4')}}</btn>
        </div>
    </div>
    <div class="flex-box mt16 flex-bet flex-a-center">
      <dropdown class="plan-dropdown" :options="status_list" :value.sync="status"/>
      <span v-if="has_sale_list" class="fs14 black-5 gl-hover-text" @click="open">{{$t('c.BlockShop.text5')}}</span>
    </div>
    <template v-if="has_sale_list">
        <plan-sale-preview v-for="(plan, i) in plan_sale_list" :key="i" :plan="plan" class="mt16"/>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  POST_EDIT_WITHDRAW,
} from "@/api/config";
export default {
  name: "block-shop",
  data() {
    return {
      ENV:this.GL.ENV,
      status:'',
    };
  },
  watch:{
    status(){
      this.get_plan()
    }
  },
  computed: {
    ...mapState("app", ["session_user", "user_status","plan_sale_list"]),
    post_data() {
      return {
        realname: this.realname,
        account: this.account,
        type: this.pay_type == 'paypal' ? 2 : 1,
      };
    },
    status_list(){
      return [
          {name:this.$t('c.BlockShop.text6'), value:''},
          {name:this.$t('c.BlockShop.text7'), value:'1'},
          {name:this.$t('c.BlockShop.text8'), value:'3'},
      ]
    },
    has_sale_list(){
      return this.plan_sale_list.length > 0 && this.plan_sale_list[0] && this.plan_sale_list[0].plan_id
    },
    plan_post_data(){
      return {
        status:this.status
      }
    },
    is_creator() {
      if (
        this.session_user &&
        this.session_user.creator &&
        this.session_user.creator.status
      ) {
        return true;
      }
      return false;
    },
    can_add_bundle() {
      return (
        this.session_user &&
        this.session_user.rights &&
        this.session_user.rights.bundle
      );
    },
  },
  async beforeMount() {
    this.get_plan()
  },
  beforeDestroy(){
      this.$bus.$off('VISIBILITYCHANGE')
      this.$bus.$off('MODAL_SHOP_SAVE_SUCCESS')
  },
  mounted() {
    this.$bus.$on('VISIBILITYCHANGE', (data) => {
      if(data.is_show){
        this.get_plan()
      }
    });
    this.$bus.$on('MODAL_SHOP_SAVE_SUCCESS', () => {
      this.get_plan()
    });
    // this.$mixin_show_modal_bundle_type()
    // this.get_withdraw();
  },
  methods: {
    get_plan(){
      this.$store.dispatch("app/get:plan_list",this.plan_post_data);
    },
    select_pay(data){
        this.pay_type = data.type
    },
    async save() {
      if (this.$http.is_run(POST_EDIT_WITHDRAW)) {
        return false;
      }
      let data = await this.$http.$axios(POST_EDIT_WITHDRAW, this.post_data);

      this.$notify({
        title: data.em,
        group: data.ec == 200 ? "success" : "error"
      });
      if (data.ec == 200) {
        this.$emit("save");
        this.$store.dispatch("app/set:session_user"); //保存成功更新session_user状态
      }
    },
    open(){
      this.$mixin_show_modal_shop({
        list:this.plan_sale_list
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-block-shop {
  .plan-dropdown /deep/{
    border:0;
    .show-area{
      padding: 4px 12px 4px 0;
      color:$black-5;
    }
  }

  @media (max-width: $width-mobile) {
    .btn-box{
      position:fixed;
      left:0;
      width:100%;
      bottom:0;
      padding:16px 16px 16px 16px;
      border-radius:10px 10px 0 0;
      background: $white;
      box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.03);
      z-index:1;
      box-sizing:border-box;
      .vm-btn{
        flex:1;
      }
    }
  }
}
</style>
